import projectTemplateDe from '@client-shared/project-templates/default.de'
import projectTemplateEn from '@client-shared/project-templates/default.en'
import projectTemplateEnGb from '@client-shared/project-templates/default.en-gb'
import projectTemplateEnUs from '@client-shared/project-templates/default.en-us'
import emailValidationRegex from '@client-shared/utils/email-validation-regex-clients'
import isOnLocalhost from '@client-shared/utils/is-on-localhost.js'

import constants from '@/config/constants.js'

const API_VERSION = 'api/v2/'

export const baseConfig = {
  showDevLogins: false,
  showBuildDateInFooter: false,
  BACKUP_APP_SIZE: 9542041, // bytes
  TILE_SIZE: constants.TILE_SIZE,
  debug: {
    isNetworkSlowdownActive: isOnLocalhost && false, // check for hostname to ensure this is never activated on app.planfred.com
  },
  trialPeriodDurationInDays: 30, // fallback only - payment.trialperioddays wins, see server/TRIAL-PERIOD.md
  api: {
    apiversion: API_VERSION,
    host: `/${API_VERSION}`, // default API host is same host with /api/v#/ prefix
    companionUrl: `/${API_VERSION}`, // default API host is same host with /api/v#/ prefix
  },
  customerFeatures: {
    isUserAllowedToCreateNewProject: () => true,
    enableAgbPrivacyConfirmation: false,
    disableUserRegistrationForm: true,
    htmlTagClass: '',
    hideFeatureAlerts: true,
    account: {
      disablePayment: true,
      disableDelete: true,
      disableUsedStorage: true,
    },
  },
  maxSizeForBase64Conversion: 1024 * 1024 * 10, // 10 MB
  maxAllowedPhotoPins: 1,
  showGoToWebsiteLink: false,
  useUtmParamsForWebsiteLinks: false, // never tag links on enterprise white-label hosts
  utmSource: 'app-planfred',
  logoPath: new URLsrc/assets/img/logo-planfred.svg', import.meta.url).href,
  tasksBetaUsers: [], // If an array entry matches with the logged in users email (regex), a user can see the tasks tab
  headTitleTag: 'PLANFRED',
  emailRegex: emailValidationRegex,
  defaultTimezone: 'Europe/Vienna',
  dateFormatFilename: 'YYYY-MM-DD_HH-mm',
  constants,
  newRevisionUploadPollTimeout: 5000, // Timeout for polling interval on new revisions
  startupDate: new Date(),
  daysUntilHardReload: 2, // Only WHOLE numbers allowed [1, 2, 3, ...],
  planfredDataMigrationUser: '111111111111111111111111',
  maxGroupImportCount: 25,
  MULTI_ACTION_BATCH_SIZE: 50,
  i18n: {
    availableLocales: [
      {
        code: 'de',
        iso: 'de-DE',
        labelLong: 'Deutsch',
        labelShort: 'DE',
      },
      {
        code: 'en',
        iso: 'en',
        labelLong: 'English',
        labelShort: 'EN',
      },
      {
        code: 'en-gb',
        iso: 'en-GB',
        labelLong: 'English',
        labelShort: 'EN',
      },
      {
        code: 'en-us',
        iso: 'en-US',
        labelLong: 'English',
        labelShort: 'EN',
      },
    ],
  },
  projectTemplates: {
    de: projectTemplateDe,
    en: projectTemplateEn,
    'en-gb': projectTemplateEnGb,
    'en-us': projectTemplateEnUs,
  },
  awsS3PublicReadFolder: 'public',
  availableCountryCodes: [ // Taken from https://gist.github.com/jylopez/7a3eb87e94981a579303a73cf72a5086
    'au',
    'at',
    'be',
    'bg',
    'br',
    'ca',
    'cy',
    'cz',
    'dk',
    'ee',
    'fi',
    'fr',
    'de',
    'gr',
    'hk',
    'hu',
    'hr',
    'in',
    'ie',
    'it',
    'jp',
    'lv',
    'li',
    'lt',
    'lu',
    'my',
    'mt',
    'mx',
    'nl',
    'nz',
    'no',
    'pl',
    'pt',
    'ro',
    'sg',
    'sk',
    'si',
    'es',
    'se',
    'ch',
    'gb',
    'us',
  ],
}
